// Formatting helpers. All dates/numbers are rendered in Geist Mono in the UI.

export function fmtDate(d: string | Date | null | undefined, locale = 'en', tz?: string): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric', timeZone: tz });
}

export function fmtDateShort(d: string | Date | null | undefined, locale = 'en', tz?: string): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(locale, { day: '2-digit', month: 'short', timeZone: tz });
}

/** Initials for an avatar chip (max 2 chars), from a display name or email. */
export function initials(name?: string | null): string {
  if (!name) return '—';
  const base = (name.includes('@') ? name.split('@')[0] : name) || name;
  const parts = base.split(/[\s._-]+/).filter(Boolean);
  const two = (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '');
  return (two || base.slice(0, 2)).toUpperCase();
}
